<agr-form-dialog [formGroup]="formGroup" [data]="data" (confirm)="process($event)" (cancel)="cancel($event)" (alt)="alt($event)">
  <div class="spacing--margin-top dialog">
    @if (!products?.length) {
      <div class="spacing--margin-all">
        {{ 'noItemsInPeriod' | translate }}
      </div>
    }
    @if (products?.length) {
      <div>
        @if (products?.length) {
          <div class="flex--row flex--gutter">
            <div class="flex__child">
              <mat-form-field class="full-width-field">
                <mat-label>{{ 'from' | translate }}</mat-label>
                <mat-select [disabled]="true" formControlName="fromPeriod">
                  <mat-option [value]="fromPeriod.id">
                    {{ fromPeriod.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="flex__child">
              <mat-form-field class="full-width-field">
                <mat-label>{{ 'to' | translate }}</mat-label>
                <mat-select formControlName="toPeriod" data-test="editTreatment-period-id" panelWith="auto">
                  @for (period of selectableToPeriods; track period) {
                    <mat-option [value]="period.id">
                      {{ period.name }}
                      ({{ period.startDispatchFrom | agrDate: 'shortDate' }} {{ 'until' | translate }} {{ period.deliverBefore | agrDate: 'shortDate' }})
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        }
        <div>
          <h3 class="text--h5">{{ 'selectedProducts' | translate }}</h3>
        </div>
        <div class="spacing--margin-bottom" formArrayName="selectedProducts">
          <div>
            <mat-checkbox
              class="spacing--margin-half-vertical"
              [name]="'allSelected'"
              [(ngModel)]="allSelected"
              [ngModelOptions]="{ standalone: true }"
              (change)="selectAll($event.checked)"
              [indeterminate]="someComplete()"
            >
              {{ 'selectAll' | translate }}
            </mat-checkbox>
          </div>
          <mat-divider></mat-divider>
          @for (product of products; track product; let i = $index) {
            <div>
              <div class="spacing--margin-half-vertical">
                <mat-checkbox
                  [name]="product.name"
                  [(ngModel)]="product.selected"
                  [ngModelOptions]="{ standalone: true }"
                  [indeterminate]="somePackagesComplete(product)"
                  (change)="updateAllSelected(product)"
                >
                  {{ product.name }}
                </mat-checkbox>
                @if (product.packages.length > 1) {
                  <div>
                    @for (package of product.packages; track package) {
                      <div class="spacing--margin-left spacing--margin-half-vertical">
                        <mat-checkbox
                          [name]="package.packageName"
                          [(ngModel)]="package.selected"
                          [ngModelOptions]="{ standalone: true }"
                          (change)="updatePackageSelected(product)"
                        >
                          {{ package.packageName }}
                        </mat-checkbox>
                      </div>
                    }
                  </div>
                }
              </div>
              <mat-divider></mat-divider>
            </div>
          }
        </div>
      </div>
    }
  </div>
</agr-form-dialog>
